import { Radio, Segmented } from "antd";

const TabsBtn = ({ alignKey, title, alignValue, handleAlignChange, options, disabled }) => {
  return (
    <div className="mt-3" style={{ background: "#ffffff", padding: "16px" }} key={alignKey}>
      {/* <label className="form-label" style={{ fontSize: "18px" }}> */}
      {title}
      {/* </label> */}
      <p className="mb-2" style={{ fontSize: "16px" }}>
        Select score according to the question.
      </p>
      <Segmented
        className="w-100 segmented-equal fs-6"
        value={alignValue}
        onChange={handleAlignChange}
        options={options.map((item) => ({
          label: (
            <div className="d-flex align-items-center">
              <Radio checked={alignValue === item.value} />
              <p className="ms-2">{item.label}</p>
            </div>
          ),
          value: item.value,
        }))}
        key={alignKey}
        style={{
          // backgroundColor: "#f3f3f36a",
          backgroundColor: "#ffffffff",
        }}
        disabled={disabled}
      />
    </div>
  );
};

export default TabsBtn;
